/**
 * @param {number} textLength
 * @param {{ min?: number, max?: number }} [opts]
 */
export function computeStreamTypingDuration(textLength, opts = {}) {
  const min = opts.min ?? 3000
  const max = opts.max ?? 6000
  if (!textLength) return min
  const ratio = Math.min(1, textLength / 500)
  return Math.round(min + ratio * (max - min))
}

/**
 * @param {number} durationMs
 * @param {number} textLength
 */
export function computeCharInterval(durationMs, textLength) {
  const len = Math.max(1, textLength)
  return Math.max(1, Math.floor(durationMs / len))
}

/**
 * @param {number} min
 * @param {number} max
 */
export function randomBetween(min, max) {
  return Math.round(min + Math.random() * (max - min))
}

/** @param {number} ms @param {number} [speedFactor] Values < 1 run faster (e.g. 0.5 = 2× speed). */
export function scaleStreamDelay(ms, speedFactor = 1) {
  return Math.max(2, Math.round(ms * speedFactor))
}

/** @param {number[]} optionsMs e.g. [2000, 3000, 4000, 6000] */
export function randomPickPauseMs(optionsMs) {
  if (!optionsMs.length) return 3000
  return optionsMs[Math.floor(Math.random() * optionsMs.length)]
}
